module.exports = __webpack_public_path__ + "static/beauty-box-9aec1baf18fe7f0148a3e0adf0398e8c.jpg";